<template>
  <div id="home">
    <headTop></headTop>
    <router-view ></router-view>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
    import headTop from '../components/headTop'
    import footerNav from '../components/footerNav'
    export default {
        name: "home",
        components: {
            headTop,
            footerNav
        },
    }
</script>

<style scoped lang='scss'>

</style>
